import { render, staticRenderFns } from "./GruoisListAlumnos.vue?vue&type=template&id=58e32e7e"
import script from "./GruoisListAlumnos.vue?vue&type=script&lang=js"
export * from "./GruoisListAlumnos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports